import { DEFAULT_CONTENT, parseContent } from 'client/data/cms/content';
import { DATA_POINTS_POSITION } from 'site-modules/editorial/constants/best';
import { isBestContent } from 'site-modules/editorial/utils/best';
import { siteServedAdsCriticalCss } from 'site-modules/shared/components/native-ad/utils/utils';

export const TEMPLATE_KEY_ONE_COLUMN = 'one-column';
export const TEMPLATE_KEY_TWO_COLUMN = 'two-column';

export function getBestKeys(content) {
  const firstCardSection =
    content
      .child('main')
      .children()
      .find(entry => entry.metadata('renderType').value() === 'card') || DEFAULT_CONTENT;
  const firstCard = firstCardSection.children().find(entry => entry.metadata('renderType').value() === 'card');

  const hasHighlightVideo = !!content.child('highlight-video').metadata('videoId').value();

  const hasSubnav = !!content.child('subnav').links()?.length;

  return {
    isFirstCardReverseData:
      !!firstCard &&
      firstCard.metadata('card-display-data').value(DATA_POINTS_POSITION.TOP) === DATA_POINTS_POSITION.TOP,
    hasHighlightVideo,
    hasSubnav,
  };
}

export function getOneColumnKeys(content) {
  const heroPhoto = content.child('hero-content').links()[0];
  const { summary } = content;
  const subnavEntry = content.child('subnav');

  return {
    heroPhoto: !!heroPhoto,
    summary: !!summary,
    subnavEntry: !!subnavEntry.links().length,
  };
}

export function getArticleCriticalCssKeys(templateKey, article, { siteServedAds, hasEvRangeTable } = {}) {
  const content = parseContent(article);

  if (isBestContent(article.id)) {
    return {
      templateKey: 'best',
      ...getBestKeys(content),
      ...siteServedAdsCriticalCss(siteServedAds),
    };
  }

  if (templateKey === TEMPLATE_KEY_ONE_COLUMN) {
    return { templateKey, hasEvRangeTable, ...getOneColumnKeys(content) };
  }

  if (templateKey === TEMPLATE_KEY_TWO_COLUMN) {
    return { templateKey };
  }

  return {};
}
